import apiService from "./apiService";
import { Requirement } from "../types/deals";
import { SimulationOverride } from "../types/lender";
import { LenderMatchResponse, EligibilityResult, AllocationCombination, MatchRequirement } from "../types/lenderMatching";

export function toMatchRequirement(requirement: Requirement): MatchRequirement {
  const extended = requirement as Requirement & {
    creditRating?: string;
    turnover?: number;
    assetCategory?: string;
  };

  return {
    id: String(requirement.id ?? requirement.requirementId ?? ""),
    type: String(requirement.type ?? requirement.productTypeName ?? ""),
    quantum: requirement.quantum,
    tenure: requirement.tenure,
    products: (requirement.products ?? []).map(String),
    asset_category_id: requirement.asset_category_id,
    assetCategoryName: requirement.assetCategoryName,
    assetCategory:
      extended.assetCategory ??
      (requirement.asset_category_id != null
        ? String(requirement.asset_category_id)
        : requirement.assetCategoryName),
    creditRating: extended.creditRating,
    turnover: extended.turnover,
  };
}

/** Normalize API body � handles { data: {...} } or direct payload. */
export function unwrapLenderMatchResponse(res: unknown): LenderMatchResponse {
  const root = (res ?? {}) as Record<string, unknown>;
  const level1 =
    root.data && typeof root.data === "object" && !Array.isArray(root.data)
      ? (root.data as Record<string, unknown>)
      : root;

  const eligibilityRaw = (level1.eligibility ?? {}) as Record<string, unknown>;
  const eligibility: EligibilityResult = {
    matched: Array.isArray(eligibilityRaw.matched) ? eligibilityRaw.matched : [],
    notMatched: Array.isArray(eligibilityRaw.notMatched)
      ? eligibilityRaw.notMatched
      : Array.isArray(eligibilityRaw.not_matched)
        ? eligibilityRaw.not_matched
        : [],
  };

  const combinations = Array.isArray(level1.combinations) ? level1.combinations : [];
  const analysis = typeof level1.analysis === "string" ? level1.analysis : "";

  if (!level1.eligibility && eligibility.matched.length === 0 && eligibility.notMatched.length === 0) {
    throw new Error("Invalid lender match response");
  }

  return { eligibility, combinations, analysis };
}

export async function fetchLenderMatch(params: {
  requirementId?: string;
  requirement?: MatchRequirement;
  overrides?: SimulationOverride[];
}): Promise<LenderMatchResponse> {
  const res = await apiService.post<unknown>("/lender-matching/match", params as Record<string, unknown>);
  return unwrapLenderMatchResponse(res);
}

